import { RouteNames } from './route-names';
import { simplePath } from './simple-path';
const app_cache = new Map();
function cache_me(path, param, params) {
    let { organization, project, application, tag, environment, versionId, query } = param;
    var _ref, _ref1;
    if (!(organization === null || organization === void 0 ? void 0 : organization.name) || !(project === null || project === void 0 ? void 0 : project.name) || !(application === null || application === void 0 ? void 0 : application.name)) {
        return '/';
    }
    const queryParams = query ? new URLSearchParams(query.replace('?', '')) : new URLSearchParams();
    if (versionId) {
        queryParams.set('versionId', versionId);
    }
    if (params) {
        Object.entries(params).forEach((param)=>{
            let [key, value] = param;
            if (value) {
                queryParams.set(key, value);
            }
        });
    }
    const queryString = queryParams.toString() ? "?".concat(queryParams.toString()) : '';
    const cache_key = "".concat(path, ":").concat(organization.name, ":").concat(project.name, ":").concat(application.name, ":").concat((_ref = tag === null || tag === void 0 ? void 0 : tag.name) !== null && _ref !== void 0 ? _ref : '', ":").concat((_ref1 = environment === null || environment === void 0 ? void 0 : environment.name) !== null && _ref1 !== void 0 ? _ref1 : '', ":").concat(versionId !== null && versionId !== void 0 ? versionId : '', ":").concat(queryString);
    if (app_cache.has(cache_key)) {
        var _app_cache_get;
        return (_app_cache_get = app_cache.get(cache_key)) !== null && _app_cache_get !== void 0 ? _app_cache_get : '/';
    }
    const urlParams = {
        organization: organization.name,
        project: project.name,
        application: application.name,
        tag: tag === null || tag === void 0 ? void 0 : tag.name,
        environment: environment === null || environment === void 0 ? void 0 : environment.name
    };
    const url = simplePath(path, urlParams) + queryString;
    app_cache.set(cache_key, url);
    return url;
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_overview_path(props) {
    return cache_me(RouteNames.APPLICATION_OVERVIEW, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/versions"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_versions_path(props, params) {
    return cache_me(RouteNames.APPLICATION_VERSIONS, props, params);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/uml"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_uml_path(props) {
    return cache_me(RouteNames.APPLICATION_UML, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/module"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_remotes_path(props) {
    return cache_me(RouteNames.APPLICATION_REMOTES, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/module/$module"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name', module: 'module-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_module_path(props) {
    var _props_query;
    var _props_organization, _props_project, _props_application;
    if (!((_props_organization = props.organization) === null || _props_organization === void 0 ? void 0 : _props_organization.name) || !((_props_project = props.project) === null || _props_project === void 0 ? void 0 : _props_project.name) || !((_props_application = props.application) === null || _props_application === void 0 ? void 0 : _props_application.name) || !props.module) {
        return '/';
    }
    return simplePath(RouteNames.APPLICATION_MODULE, {
        organization: props.organization.name,
        project: props.project.name,
        application: props.application.name,
        module: props.module
    }) + ((_props_query = props.query) !== null && _props_query !== void 0 ? _props_query : '');
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/analytics/dependencies"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_dependencies_path(props) {
    return cache_me(RouteNames.APPLICATION_DEPENDENCIES, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/analytics/node-graph"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_node_graph_path(props) {
    return cache_me(RouteNames.APPLICATION_NODE_GRAPH, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/analytics/dependency-graph"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_dependency_graph_path(props) {
    return cache_me(RouteNames.APPLICATION_DEPENDENCY_GRAPH, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/analytics/node-dependencies/$applicationId"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name', applicationId: 'app-id' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_node_dependencies_path(props) {
    const { organization, project, application, applicationId, query } = props;
    if (!(organization === null || organization === void 0 ? void 0 : organization.name) || !(project === null || project === void 0 ? void 0 : project.name) || !(application === null || application === void 0 ? void 0 : application.name) || !applicationId) {
        return '/';
    }
    const params = {
        organization: organization.name,
        project: project.name,
        application: application.name,
        applicationId
    };
    return simplePath(RouteNames.APPLICATION_NODE_DEPENDENCIES, params) + (query !== null && query !== void 0 ? query : '');
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/settings"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_settings_general_path(props) {
    return cache_me(RouteNames.APPLICATION_SETTINGS, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/settings/contributor-list"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_contributor_list_path(props) {
    return cache_me(RouteNames.APPLICATION_CONTRIBUTOR_LIST, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/settings/devops/tags"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_settings_tags_path(props) {
    return cache_me(RouteNames.APPLICATION_DEVOPS_TAGS, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/settings/devops/tags/add"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_settings_tags_add_path(props) {
    return cache_me(RouteNames.APPLICATION_DEVOPS_TAGS_ADD, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/settings/devops/tags/edit"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_settings_tags_edit_path(props) {
    return cache_me(RouteNames.APPLICATION_DEVOPS_TAGS_EDIT, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/settings/devops/environments"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_settings_environment_list_path(props) {
    return cache_me(RouteNames.APPLICATION_DEVOPS_ENVIRONMENT_LIST, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/settings/devops/environments/add"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_settings_environment_add_path(props) {
    return cache_me(RouteNames.APPLICATION_DEVOPS_ENVIRONMENT_ADD, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/settings/devops/environments/edit"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_settings_environment_edit_path(props) {
    return cache_me(RouteNames.APPLICATION_DEVOPS_ENVIRONMENT_EDIT, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/settings/deployment-integrations"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_settings_deployment_integrations_list_path(props) {
    return cache_me(RouteNames.APPLICATION_DEVOPS_DEPLOYMENT_INTEGRATION_LIST, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/devops/deployment-and-rollback"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_settings_deployment_and_rollback_path(props) {
    return cache_me(RouteNames.APPLICATION_DEVOPS_DEPLOYMENT_AND_ROLLBACK, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/release-pipeline"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_release_pipeline_path(props) {
    return cache_me(RouteNames.APPLICATION_DEVOPS_RELEASE_PIPELINE, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/release-pipeline/board"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_release_pipeline_board_path(props) {
    return cache_me(RouteNames.APPLICATION_DEVOPS_RELEASE_PIPELINE_BOARD, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/app/$application/release-pipeline/board"
 *   params={{ organization: 'org-name', project: 'project-name', application: 'app-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function application_version_detail_path(props) {
    const { organization, project, application, versionId: versionid, query } = props;
    if (!(organization === null || organization === void 0 ? void 0 : organization.name) || !(project === null || project === void 0 ? void 0 : project.name) || !(application === null || application === void 0 ? void 0 : application.name) || !versionid) {
        return '/';
    }
    const params = {
        organization: organization.name,
        project: project.name,
        application: application.name,
        versionid
    };
    return simplePath(RouteNames.APPLICATION_VERSION_DETAIL, params) + (query !== null && query !== void 0 ? query : '');
}
